export const GCF_URL_BASE = 'https://us-central1-tlm2021-41ce7.cloudfunctions.net/tlm';
export const GCF_URL_BASE_NOT_GCF_CORE = 'https://us-central1-tlm2021-41ce7.cloudfunctions.net';
export const GCF_LOCAL_BASE = 'http://localhost:5555';
